import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers } from 'recompose'

import * as OrgSelectors  from 'modules/org/selectors'
import * as OrgActions  from 'modules/org/actions'

import ColorPalette from './component'
export { Swatch } from './component'

const mapStateToProps = state => ({
  color: OrgSelectors.getColor(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setColor: OrgActions.setColor
  }, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onColorClick: props => value => () => {
      props.actions.setColor(value.replace('#', ''))
    }
  })
)(ColorPalette)